// extracted by mini-css-extract-plugin
export var completionBody = "_bz-2";
export var completionCard = "_bz-0";
export var completionFooter = "_bz-3";
export var completionTitle = "_bz-1";